import React, { useState, useEffect, useCallback } from 'react';
import { Slider } from '@mui/material';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import StopCircleRoundedIcon from '@mui/icons-material/StopCircleRounded';
import Box from '@mui/material/Box';
import { format, addHours } from 'date-fns';
import './slider_performance.css';

const TimeSliderPerformance = ({ initialDate, steps, onChange, cqlFechaMin }) => {
  // const [startDate, setStartDate] = useState(new Date(initialDate));
  const [startDate, setStartDate] = useState(new Date(cqlFechaMin));
  const [sliderValue, setSliderValue] = useState(1);
  const [isAutoPlay, setIsAutoPlay] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [adjustedDateTime, setAdjustedDateTime] = useState('');
  const [sliderThumbPosition, setSliderThumbPosition] = useState({ top: 0, left: 0 });
  const [isAlertVisible, setIsAlertVisible] = useState(true);


  const marks = Array.from({ length: steps }, (_, i) => {
    const markDate = addHours(new Date(cqlFechaMin), i);
    return {
      value: i,
      // label: `+${i}`,
      // label: format(markDate, 'HH:mm'),
      // label: format(markDate, "H'h'")
      label: format(markDate, "H")
    };
  });

  const handlePlayButtonClick = () => {
    setIsAutoPlay(!isAutoPlay);
    setIsPlaying(!isPlaying);
    setIsAlertVisible(true);
  };

  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  //La cqlFecha se actualiza a traves del onChange
  const debouncedOnChange = useCallback(
    debounce((selectedDate) => {
      onChange(format(selectedDate, 'yyyy-MM-dd HH:mm:ss'));
    }, 500),
    [onChange]
  );

  const handleSliderChange = (event, value) => {
    setSliderValue(value);
    const selectedDate = addHours(cqlFechaMin, value);
    debouncedOnChange(selectedDate);
    setAdjustedDateTime(format(selectedDate, 'yyyy-MM-dd HH:mm:ss'));
    setIsAlertVisible(true);
  };

  useEffect(() => {
    if (document.querySelector('.horizontal-slider .thumb')) {
      const sliderThumb = document.querySelector('.horizontal-slider .thumb');
      const sliderRect = sliderThumb.getBoundingClientRect();
      setSliderThumbPosition({
        top: sliderRect.top - 500,
        left: sliderRect.left + sliderRect.width / 2,
      });
    }
  }, [sliderValue]);

  useEffect(() => {
    if (isAutoPlay) {
      const interval = setInterval(() => {
        setSliderValue((prevValue) => {
          const nextValue = prevValue < steps - 1 ? prevValue + 1 : 0;
          const newDateTime = addHours(startDate, nextValue);
          debouncedOnChange(newDateTime);
          setAdjustedDateTime(format(newDateTime, 'yyyy-MM-dd HH:mm:ss'));
          return nextValue;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isAutoPlay, startDate, steps, debouncedOnChange]);

  // useEffect para actualizar cqlFecha y en consecuencia cqlFechaMin si cambio la cqlFecha en el calendario
  useEffect(() => {
    setStartDate(new Date(cqlFechaMin)); // Actualiza startDate cuando cqlFechaMin cambie
  }, [cqlFechaMin]);


  //Esto para que el valor incial del thumb se tome en consecuencia
  useEffect(() => {
    // Se asegura que cqlFechaMin esté definido y se actualiza el valor asociado
    if (cqlFechaMin) {
      const initialDate = addHours(new Date(cqlFechaMin), sliderValue);
      setAdjustedDateTime(format(initialDate, 'yyyy-MM-dd HH:mm:ss'));
      // Si es necesario, se puede llamar a onChange para notificar al componente padre
      onChange(format(initialDate, 'yyyy-MM-dd HH:mm:ss'));
    }
  }, [cqlFechaMin, sliderValue, onChange]);

  return (
    <div className="slider-container_perf">
      {isAutoPlay ? (
        <button className="custom-btn stop-btn" onClick={handlePlayButtonClick}>
          <StopCircleRoundedIcon style={{ fontSize: 28 }} />
        </button>
      ) : (
        <button className="custom-btn play-btn" onClick={handlePlayButtonClick}>
          <PlayCircleOutlineRoundedIcon style={{ fontSize: 28 }} />
        </button>
      )}
      <Box className="div-slider">
        <Slider
          value={sliderValue}
          step={1}
          marks={marks}
          min={0}
          max={steps - 1}
          onChange={handleSliderChange}
          valueLabelDisplay="auto"
          valueLabelFormat={(value) => format(addHours(startDate, value), 'yyyy-MM-dd HH:mm:ss \'UTC\'')}
          sx={{
            color: 'primary.main',
            height: 8,
            marginLeft: 8,   
            width: '92%',
            
            '& .MuiSlider-thumb': {
              height: 14,
              width: 14,
              marginTop:'1.25%',
            //   marginLeft: 6,   
              backgroundColor: '#fff',
              '&:focus, &:hover, &.Mui-active': {
                boxShadow: '0px 0px 8px 2px rgba(0,0,0,0.3)',
                height: 18,
                width: 18,
                
                // marginLeft: 6,   
              },
            },
            '& .MuiSlider-track': {
              height: 4,
              marginTop:'1.25%',
              
            //   marginLeft: 6,    
              color: '#2ecc71',
              '&:active': {
                color: 'green',
              },
            },
            '& .MuiSlider-rail': {
              color: '#a8ffd7d7',
              opacity: 1,
              height: 8,
              width: '100%',
              marginTop:'1.25%',
            //   marginLeft: 6,
            },
            '& .MuiSlider-valueLabel': {
              position: 'absolute',
              fontFamily: 'Arial',
              backgroundColor: 'YELLOW', 
              color: 'BLACK', // Verde oscuro para el texto
              transform: 'translateY(-120%) scale(1)', // Ajustado
              borderRadius: '15px',
              fontSize: '0.875rem',
              fontWeight: 'bold',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0px 4px 12px rgba(0, 128, 0, 0.3)', // Sombra verde
              marginTop:'7.5px',
            },
            '& .MuiSlider-mark': {
              backgroundColor: 'transparent',
              height: '8.5px',
              width: '2.5px',
              marginTop:'1.25%',
            //   marginLeft: 6,   
              '&::after': {
                content: '""',
                display: 'block',
                backgroundColor: '#000',
                height: '9.5px',
                width: '1.25px',
                borderRadius: 0,
              },
            },
            '& .MuiSlider-markLabel': {
              position: 'absolute',
              color: 'gray',
              fontSize: '0.75rem',
              marginTop:'1.05%',
            },
            '& .MuiSlider-markActive': {
              opacity: 0.9,
            //   marginLeft: 6,   
              backgroundColor: 'currentcolor',
              '&::after': {
                content: '""',
                display: 'block',
                backgroundColor: '#000',
                height: '9.5px',
                width: '2px',
                borderRadius: 0,
                marginTop:'1.25%',
              },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default TimeSliderPerformance;
